// extracted by mini-css-extract-plugin
export default {"trashSize":"TrashNodeLabel__trashSize--162Gg"};